import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Conversation, ConversationStatus} from '../../contracts/conversation.interface';
import {Button} from 'primeng/button';
import {ContactDisplayPipe} from '../../../shared/pipes/contact-display.pipe';

@Component({
  selector: 'kc-chat-invitation',
  imports: [
    FormsModule,
    Button,
    ContactDisplayPipe,
  ],
  templateUrl: './chat-invitation.component.html',
  styleUrl: './chat-invitation.component.scss',
})
export class ChatInvitationComponent implements OnInit {
  @Input() conversation!: Conversation;
  @Output() choiceSelected: EventEmitter<boolean> = new EventEmitter();


  ngOnInit() {}

  onChoice(choice: boolean) {
    this.choiceSelected.emit(choice);
  }

  protected readonly ConversationStatus = ConversationStatus;
}
